module.exports = __webpack_public_path__ + "static/img/time.fae94958.png";